import { render, staticRenderFns } from "./create-reporters.component.html?vue&type=template&id=37a6e5dc&scoped=true&"
import script from "./create-reporters.component.ts?vue&type=script&lang=ts&"
export * from "./create-reporters.component.ts?vue&type=script&lang=ts&"
import style0 from "./create-reporters.component.scss?vue&type=style&index=0&id=37a6e5dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a6e5dc",
  null
  
)

export default component.exports